import { render, staticRenderFns } from "./barDisplay.vue?vue&type=template&id=2ecdd70c&scoped=true"
import script from "./barDisplay.vue?vue&type=script&lang=js"
export * from "./barDisplay.vue?vue&type=script&lang=js"
import style0 from "./barDisplay.vue?vue&type=style&index=0&id=2ecdd70c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecdd70c",
  null
  
)

export default component.exports